(function () {
  const container = document.currentScript.parentElement;
  const quotes = container.querySelectorAll(".reviews__quote");
  const images = container.querySelectorAll(".reviews__image");
  const quotesWrap = container.querySelector(".reviews__quotes");
  const horizontalScroll = container.querySelector(".reviews__images");

  let index = 0;
  let start = setInterval(autoPlay, 3000);
  let minHeight = 0;

  quotes.forEach((quote) => {
    quote.offsetHeight > minHeight
      ? (minHeight = quote.offsetHeight)
      : (quote.offsetHeight = quote.offsetHeight);
  });

  quotesWrap.style.minHeight = `${minHeight}px`;

  quotes.forEach((quote, i) => {
    if (i != 0) {
      quote.classList.remove("active");
    }
  });

  function autoPlay() {
    index <= quotes.length - 2 ? index++ : (index = 0);
    quotes.forEach((quote) => quote.classList.remove("active"));
    images.forEach((image) => image.classList.remove("active"));
    images[index].classList.add("active");
    quotes[index].classList.add("active");

    let imgPos = images[index].getBoundingClientRect().left - 20;

    horizontalScroll.scrollTo({
      top: 0,
      left: imgPos,
      behavior: "smooth",
    });

    //   images[index].getBoundingClientRect().left, 0, 'smooth',)

    // horizontalScroll.scrollTo(images[index].getBoundingClientRect().left, 0, 'smooth',)
  }

  images.forEach((img) => {
    img.addEventListener("click", () => {
      clearInterval(start);
      quotes.forEach((quote) => quote.classList.remove("active"));
      images.forEach((image) => image.classList.remove("active"));
      const imgId = img.getAttribute("data-id");

      quotes.forEach((quote) => {
        const quoteId = quote.getAttribute("data-id");

        if (quoteId == imgId) {
          index = imgId;
          quote.classList.add("active");
          img.classList.add("active");
          start = setInterval(autoPlay, 3000);
        }
      });
    });
  });
})();
